import { useNavigate } from 'react-router-dom'
import { MergeValueAction } from '@/components/merge/MergeValueAction'
import type { ProductPage } from '@/domain/explore.types'
import { MetaTab } from './MetaTab'

/**
 * What ATLAS records about the product beyond what the page already shows: the Veeva
 * object it is, the ids that alias onto it, and the raw meta behind both.
 *
 * A thin wrapper over `MetaTab`, which the brand page renders as a tab and this page as
 * the last card in its sidebar — the same content, placed where each page has room.
 */
export function ProductMetaCard({ page }: { page: ProductPage }) {
	const navigate = useNavigate()
	return (
		<MetaTab
			subject="product"
			code={page.product.code}
			valueId={page.product.valueId}
			meta={page.product.meta}
			valueMeta={page.productValueMeta}
			mappings={page.namesByMarket}
			identityAction={
				<MergeValueAction
					valueId={page.product.valueId}
					code={page.product.code}
					label={page.product.name}
					// A merged product's page is a 404 the moment the mutation lands, so the reader
					// goes back to Explore rather than watching this one fail to reload.
					onMerged={() => void navigate('/explore')}
				/>
			}
		/>
	)
}
